<div class="profile-general-info" [class.profile-general-info--child]="!isPrimaryCustomer">

    <div class="profile-general-title-wrap">

        <div class="profile-general-title rpc-title-font">
            {{ 'PROFILE.TITLES.CONTACT_INFORMATION' | translate }}
        </div>

    </div>

    @if (isPrimaryCustomer && isSelfProfile) {

    <div class="profile-general-info-item">

        <div class="profile-general-info-item-title rpc-title-font">
            {{ 'PROFILE.TITLES.EMAILS' | translate }}
        </div>

        <emails-list class="profile-general-info-item-block" [emails]="emails">
        </emails-list>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-general-info-divider">
    </div>

    }

    <div class="profile-general-info-item">

        <div class="profile-general-info-item-title rpc-title-font">
            {{ 'PROFILE.TITLES.PHONES' | translate }}
        </div>

        <phones-list class="profile-general-info-item-block" [phones]="phones">
        </phones-list>

    </div>

    <div class="rpc-divider rpc-divider--horizontal profile-general-info-divider">
    </div>

    <div class="profile-general-info-item">

        <div class="profile-general-info-item-title rpc-title-font">
            {{ 'PROFILE.TITLES.ADDRESSES' | translate }}
        </div>

        <addresses-list class="profile-general-info-item-block" [addresses]="addresses">
        </addresses-list>

    </div>

</div>